import { agent } from '@shared/services/agent';
import { Moment } from "moment";
import { DATE_FORMAT } from "@shared/utils/DateUtils";
import { MovementDay } from '@features/whereabouts/models/movements.models';

// Mirrors the backend WeekNoteScope enum. Notes are queried by the owner's membership; scope is
// never stored on the note.
type WeekNoteScopeType = 'TEAM' | 'DEPARTMENT' | 'WORKGROUP';

export interface WeekNoteScope {
  type: WeekNoteScopeType;
  id: string;
}

export async function getWeeklyNotesForScopes(scopes?: WeekNoteScope[], date?: Moment): Promise<WeekNote[]> {
  if (!scopes || scopes.length === 0 || !date) return [];
  const response = await Promise.all(scopes.map(async (scope) =>
    await agent.requests.get(`/api/week-notes?scopeType=${scope.type}&scopeId=${scope.id}&date=${date.format(DATE_FORMAT)}`)));
  return response.flat();
}

export async function getWeeklyTeamNoteForUser(userId?: string, date?: Moment): Promise<WeekNote> {
  if (!userId || !date) throw new Error('No userId or date');
  return await agent.requests.get(`/api/week-notes/user/${userId}?date=${date.format(DATE_FORMAT)}`);
}

export async function saveWeeklyNotes(userId: string, date: Moment, note: string): Promise<void> {
  return await agent.requests.post(`/api/week-notes`, {
    userId: userId,
    date: date.format(DATE_FORMAT),
    note: note,
  })
}

export interface WeekNote {
  notesId: number;
  // Week-commencing date this note belongs to. The API resolves notes per week and does not echo the
  // week back, so this is tagged client-side when notes are fetched across several weeks (month view).
  weekCommencing?: string;
  userId: string;
  teamId: string;
  teamName: string;
  firstName: string;
  lastName: string;
  note: string;
  lastUpdated: string;
  whereabouts: MovementDay[];
  usersDayNotes?: DayNote[];
}

export interface DayNote {
  createdAt: string;
  date: string
  id: number;
  note: string;
  whereaboutsDayId: number;
}
